/*!
 * referral-bar.js — Portatif referans trust-bar modülü (vanilla, bağımlılıksız).
 * Reklam/link kaynağına (Meta / Google) göre EN TEPEDE bir bar gösterir.
 * Herhangi bir Shopify temasına veya Next.js (D2C) sayfasına düşer:
 *   <script src="referral-bar.js"></script>
 *   <script>ReferralBar.init({ ...config... });</script>
 * Kendi DOM'unu + CSS'ini + header/body offset'ini enjekte eder; sessionStorage ile
 * oturum boyunca kalır; X ile kapatılınca o oturum gizli. CLS-yok için init'i sayfanın
 * EN BAŞINDA (header'dan önce) senkron çağır.
 * Güvenlik: dinamik metin textContent ile basılır (XSS yok); innerHTML yalnız sabit SVG için.
 */
(function (w, d) {
  'use strict';
  if (w.ReferralBar) return;

  var SVG = {
    instagram: '<svg viewBox="0 0 24 24" width="27" height="27" fill="none" xmlns="http://www.w3.org/2000/svg"><defs><linearGradient id="rbarIg" x1="2" y1="22" x2="22" y2="2" gradientUnits="userSpaceOnUse"><stop stop-color="#FEDA75"/><stop offset=".35" stop-color="#FA7E1E"/><stop offset=".62" stop-color="#D62976"/><stop offset=".85" stop-color="#962FBF"/><stop offset="1" stop-color="#4F5BD5"/></linearGradient></defs><rect x="2.2" y="2.2" width="19.6" height="19.6" rx="6" stroke="url(#rbarIg)" stroke-width="2"/><circle cx="12" cy="12" r="4.6" stroke="url(#rbarIg)" stroke-width="2"/><circle cx="17.4" cy="6.6" r="1.4" fill="url(#rbarIg)"/></svg>',
    google: '<svg viewBox="0 0 48 48" width="25" height="25" xmlns="http://www.w3.org/2000/svg"><path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/><path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/><path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/><path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/></svg>',
    close: '<svg width="13" height="13" viewBox="0 0 14 14" fill="none" aria-hidden="true"><path d="M2 2L12 12M12 2L2 12" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>'
  };

  /* Kaynak hesabı — yalnız MEVCUT URL/referrer/UA (cache'siz). */
  function compute(cfg) {
    var q = (location.search || '').toLowerCase();
    var ref = (d.referrer || '').toLowerCase();
    var ua = navigator.userAgent || '';
    if (cfg.variants.meta && (
        q.indexOf('fbclid=') > -1 ||
        /utm_source=(instagram|ig|facebook|fb|meta)/.test(q) ||
        /(^|\.)(instagram|facebook)\.com|l\.instagram\.com|l(m)?\.facebook\.com/.test(ref) ||
        /(FBAN|FBAV|FB_IAB|FB4A|Instagram|IGAB)/i.test(ua))) {
      return 'meta';
    }
    if (cfg.variants.google && (
        q.indexOf('gclid=') > -1 ||
        q.indexOf('gad_source=') > -1 ||
        /utm_source=google/.test(q) ||
        /(^|\.)google\.[a-z.]+\//.test(ref + '/') ||
        /googleadservices|googlesyndication|doubleclick/.test(ref))) {
      return 'google';
    }
    return null;
  }

  /* Tespit: önce TAZE URL sinyali (cache'i ezer), yoksa navigasyon için cache fallback. */
  function detect(cfg) {
    var SK = cfg.storageKey, XK = cfg.storageKey + '_x';
    try { if (sessionStorage.getItem(XK) === '1') return null; } catch (e) {}
    var fresh = compute(cfg);
    if (fresh) { try { sessionStorage.setItem(SK, fresh); } catch (e) {} return fresh; }
    try { var saved = sessionStorage.getItem(SK); if (saved && cfg.variants[saved]) return saved; } catch (e) {}
    return null;
  }

  function buildCss(cfg) {
    var hMob = cfg.heightMobile || cfg.height;
    var s = [];
    s.push('html.rbar-on{--rbar-h:' + cfg.height + 'px}');
    s.push('@media(max-width:699px){html.rbar-on{--rbar-h:' + hMob + 'px}}');
    if (cfg.headerSelector) s.push('html.rbar-on ' + cfg.headerSelector + '{top:var(--rbar-h)!important}');
    s.push('html.rbar-on body{padding-top:calc(' + (cfg.bodyBasePad || '0px') + ' + var(--rbar-h))!important}');
    if (cfg.extraCss) s.push(cfg.extraCss);
    s.push('.rbar{display:flex;align-items:center;position:fixed;top:0;left:0;right:0;z-index:' + (cfg.zIndex || 2147483000) + ';height:var(--rbar-h);text-decoration:none;border-bottom:2px solid transparent;font-family:inherit;box-sizing:border-box}');
    s.push('.rbar__in{display:flex;align-items:center;gap:11px;height:100%;width:100%;max-width:' + (cfg.maxWidth || 1200) + 'px;margin:0 auto;padding:0 ' + (cfg.gutter || 20) + 'px;box-sizing:border-box}');
    s.push('.rbar__logo{flex-shrink:0;display:inline-flex;align-items:center;line-height:0}');
    s.push('.rbar__copy{display:flex;flex-direction:column;gap:1px;flex:1 1 auto;min-width:0;text-align:left}');
    s.push('.rbar__t,.rbar__s{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}');
    s.push('.rbar__t{font-size:14px;font-weight:600;letter-spacing:.02em;line-height:1.25}');
    s.push('.rbar__s{font-size:12px;font-weight:500;letter-spacing:.02em;line-height:1.2}');
    s.push('.rbar__r{flex-shrink:0;margin-left:auto;padding-left:10px;display:flex;flex-direction:column;align-items:flex-end;gap:1px;text-align:right}');
    s.push('.rbar__rv{font-size:24px;font-weight:800;line-height:1.05;white-space:nowrap}');
    s.push('.rbar__rc{font-size:13px;font-weight:600;white-space:nowrap}');
    s.push('.rbar__x{flex-shrink:0;margin-left:12px;width:30px;align-self:stretch;display:flex;align-items:center;justify-content:center;cursor:pointer;-webkit-tap-highlight-color:transparent;transition:color .15s ease}');
    s.push('@media(max-width:699px){.rbar__in{gap:8px;padding:0 14px}.rbar__logo svg{width:25px;height:25px}.rbar__t{font-size:13px;line-height:1.18;white-space:normal;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical}.rbar__s{font-size:11px}.rbar__rv{font-size:21px}.rbar__rc{font-size:12px}.rbar__x{margin-left:6px;width:26px}}');
    s.push('@media(max-width:480px){.rbar__in{gap:7px;padding:0 12px}.rbar__t{font-size:12.5px}.rbar__r{padding-left:8px}.rbar__rv{font-size:19px}.rbar__rc{font-size:11px}.rbar__x{margin-left:4px}}');
    s.push('@media(max-width:374px){.rbar__rsx{display:none}}');
    s.push('.rbar-dark .rbar{background:#190a14;border-image:linear-gradient(90deg,#FEDA75,#FA7E1E,#D62976,#962FBF,#4F5BD5) 1}');
    s.push('.rbar-dark .rbar:active{background:#271120}');
    s.push('.rbar-dark .rbar__t,.rbar-dark .rbar__rv{color:#fff}.rbar-dark .rbar__s{color:rgba(255,255,255,.6)}');
    s.push('.rbar-dark .rbar__star{color:#FFC93C;font-weight:400}.rbar-dark .rbar__rc{color:rgba(255,255,255,.85)}');
    s.push('.rbar-dark .rbar__x{color:rgba(255,255,255,.5)}.rbar-dark .rbar__x:hover{color:#fff}');
    s.push('.rbar-light .rbar{background:#fff;border-image:linear-gradient(90deg,#4285F4,#EA4335,#FBBC05,#34A853) 1;box-shadow:0 1px 0 rgba(0,0,0,.04)}');
    s.push('.rbar-light .rbar:active{background:#f7f8fa}');
    s.push('.rbar-light .rbar__t,.rbar-light .rbar__rv{color:#1a1a1a}.rbar-light .rbar__s{color:rgba(0,0,0,.55)}');
    s.push('.rbar-light .rbar__star{color:#F5A300;font-weight:400}.rbar-light .rbar__rc{color:rgba(0,0,0,.6)}');
    s.push('.rbar-light .rbar__x{color:rgba(0,0,0,.4)}.rbar-light .rbar__x:hover{color:#000}');
    return s.join('');
  }

  /* Güvenli DOM kurulumu — dinamik metin textContent; innerHTML yalnız sabit SVG. */
  function elx(tag, cls) { var e = d.createElement(tag); if (cls) e.className = cls; return e; }
  function txt(cls, t) { var e = elx('span', cls); e.textContent = t == null ? '' : t; return e; }
  function svgEl(cls, key) { var e = elx('span', cls); e.setAttribute('aria-hidden', 'true'); e.innerHTML = SVG[key] || ''; return e; }

  function buildBar(cfg, v) {
    var external = cfg.link && cfg.link.indexOf('//') > -1;
    var el = elx(cfg.link ? 'a' : 'div', 'rbar');
    if (cfg.link) {
      el.setAttribute('href', cfg.link);
      if (external) { el.setAttribute('target', '_blank'); el.setAttribute('rel', 'noopener nofollow'); }
    }
    el.setAttribute('role', 'note');
    el.setAttribute('aria-label', (v.text || '') + (cfg.subtext ? ' — ' + cfg.subtext : ''));

    var inner = elx('span', 'rbar__in');
    inner.appendChild(svgEl('rbar__logo', v.logo));

    var copy = elx('span', 'rbar__copy');
    copy.appendChild(txt('rbar__t', v.text));
    if (cfg.subtext) copy.appendChild(txt('rbar__s', cfg.subtext));
    inner.appendChild(copy);

    if (cfg.rating && cfg.rating.value) {
      var r = elx('span', 'rbar__r');
      var rv = elx('span', 'rbar__rv');
      var star = elx('b', 'rbar__star'); star.textContent = '★';
      rv.appendChild(star);
      rv.appendChild(d.createTextNode(' ' + cfg.rating.value));
      r.appendChild(rv);
      if (cfg.rating.count) {
        var rc = txt('rbar__rc', cfg.rating.count);
        if (cfg.rating.suffix) rc.appendChild(txt('rbar__rsx', ' ' + cfg.rating.suffix));
        r.appendChild(rc);
      }
      inner.appendChild(r);
    }

    if (cfg.closeable) {
      var x = svgEl('rbar__x', 'close');
      x.setAttribute('data-rbar-close', '');
      x.setAttribute('role', 'button');
      x.setAttribute('tabindex', '0');
      x.setAttribute('aria-label', 'Kapat');
      inner.appendChild(x);
    }

    el.appendChild(inner);
    return el;
  }

  function ready(fn) {
    if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  var done = false;
  w.ReferralBar = {
    init: function (cfg) {
      if (done || !cfg || !cfg.variants) return;
      cfg.storageKey = cfg.storageKey || 'ref_bar';
      cfg.height = cfg.height || 56;
      if (typeof cfg.closeable === 'undefined') cfg.closeable = true;

      var src = detect(cfg);
      if (!src) return;
      done = true;
      var v = cfg.variants[src];
      var theme = v.theme === 'light' ? 'light' : 'dark';

      var st = elx('style'); st.id = 'rbar-style'; st.textContent = buildCss(cfg);
      (d.head || d.documentElement).appendChild(st);
      d.documentElement.className += ' rbar-on rbar-' + theme;

      ready(function () {
        if (!d.body || d.querySelector('.rbar')) return;
        d.body.insertBefore(buildBar(cfg, v), d.body.firstChild);
      });

      d.addEventListener('click', function (e) {
        var b = e.target && e.target.closest ? e.target.closest('[data-rbar-close]') : null;
        if (!b) return;
        e.preventDefault();
        e.stopPropagation();
        try { sessionStorage.setItem(cfg.storageKey + '_x', '1'); } catch (err) {}
        var de = d.documentElement;
        de.className = de.className.replace(/\s*\brbar-(on|dark|light)\b/g, '');
        var bar = d.querySelector('.rbar');
        if (bar && bar.parentNode) bar.parentNode.removeChild(bar);
      }, true);
    }
  };
})(window, document);


